import React from "react";
import {afterDate, composeValidators, required} from "src/core/common/validations";
import DatePicker from "src/core/common/components/elements/date-picker/DatePicker";
import Input from "src/core/common/components/elements/input/Input";
import {showErrorHighlight} from "src/core/common/utils";
import Error from "src/core/common/components/elements/Error";
import {Field} from "react-final-form";
import {FieldContainer} from "src/core/common/components/collections/form/forms";
import styled from "styled-components";
import useFeatureToggles from "src/core/common/hooks/useFeatureToggles";

function DriversLicenseIDFields({disabled}) {
  const toggles = useFeatureToggles();
  const driversLicenseIDRequired = toggles.driversLicenseIDRequired();
  const now = new Date();
  const placeholderSuffix = driversLicenseIDRequired ? "*" : "";
  return (
    <Container>
      <Field
        name="driversLicenseIdNumber"
        validate={driversLicenseIDRequired ? required : undefined}
        render={({input, meta}) => (
          <FieldContainer>
            <Input
              {...input}
              disabled={disabled}
              hasErrors={showErrorHighlight(meta)}
              placeholder={"Driver license number" + placeholderSuffix}
            />
            {meta.touched && <Error>{meta.error}</Error>}
          </FieldContainer>
        )}
      />
      <DatePicker
        name={"driversLicenseIdExpirationDate"}
        placeholder={"Expiration Date" + placeholderSuffix}
        minDate={now}
        disabled={disabled}
        validate={
          driversLicenseIDRequired
            ? composeValidators(required, afterDate(now))
            : afterDate(now)
        }
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  column-gap: 8px;
`;
export default DriversLicenseIDFields;
